import { useContext } from 'react'

import { Box, Typography } from '@mui/material'
import { IconMail, IconSparkles } from '@tabler/icons-react'
import type { CRMObject, Draft } from 'types/graphql'

import Row from 'src/components/Row/Row'
import { DayContext } from 'src/lib/dayContext'
import { NativeObjectTypes } from 'src/lib/objects'

const containerSx = {
  px: '12px',
  gap: 2,
  '& .thread-message-artifact-icon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '52px',
    height: '52px',
    backgroundColor: (theme) => theme.palette.divider,
    borderRadius: '8px',
  },

  '& .thread-message-artifact-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },

  '& .thread-message-artifact-label': {
    fontWeight: 600,
  },

  '& .thread-message-artifact-description': {
    fontSize: '12px',
    color: 'text.secondary',
  },
}

const ThreadArtifactButton = ({ artifact }: { artifact: CRMObject }) => {
  const { setSidebarObject } = useContext(DayContext)

  return (
    <Row
      sx={containerSx}
      onClick={() => {
        setSidebarObject(artifact)
      }}
    >
      <Box className="thread-message-artifact-icon">
        {artifact.objectType === NativeObjectTypes.Draft ? (
          <IconMail size={26} />
        ) : (
          <IconSparkles size={26} />
        )}
      </Box>
      <Box className="thread-message-artifact-content">
        <Row gap={0.5}>
          <IconSparkles size={12} />
          <Typography className="thread-message-artifact-label">
            {artifact.objectType === NativeObjectTypes.Draft
              ? 'Email Draft'
              : 'Artifact'}
          </Typography>
        </Row>
        <Typography className="thread-message-artifact-description">
          {artifact.objectType === NativeObjectTypes.Draft
            ? (artifact.properties as Draft)?.email?.subject
            : 'Artifact'}
        </Typography>
      </Box>
    </Row>
  )
}

export default ThreadArtifactButton
